/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsFeaturedCollection = {
    init: function ($section) {
     
      // Add settings from schema to current object
      Shopify.theme.jsFeaturedCollection = $.extend(this, Shopify.theme.getSectionData($section));

      let $sliderEl = $section.find('[data-slider]');

      if (this.collection_style == 'slider') {
        this.createSlider($sliderEl);
      }
    },
    createSlider: function ($sliderEl) {

      if ($sliderEl.hasClass('flickity-enabled')) {
        $sliderEl.flickity('destroy');
      }

      const slideData = {
        products_per_slide: this.products_per,
        products_available: this.products_available,
        products_limit: this.products_limit,
        loop_slider: this.loop_slider,
        dots_slider: this.dots_slider,
      }


      // if (
      //   window.innerWidth > 798 &&
      //   this.enable_slider_overflow
      // ) {
      //   const containerEl = $sliderEl.closest('.section').find('.container').first()[0];
      //   const leftSpace = containerEl ? containerEl.getBoundingClientRect().left : 0;

      //   console.log("enable_slider_overflow:", this.enable_slider_overflow);

      //   $sliderEl.css({
      //     maxWidth: 'none',
      //     width: '100vw',
      //     marginLeft: `-${leftSpace}px`,
      //     paddingLeft: `${leftSpace}px`,
      //     overflow: 'visible'
      //   });

      //   $sliderEl.flickity('resize');
      // }
         
      const slider = $sliderEl.flickity({
         lazyLoad: 2,
        freeScroll: true,
        imagesLoaded: true,
        draggable: true,
        cellAlign: "left",
        wrapAround: false,
        pageDots: slideData.dots_slider,
        contain: false,
        prevNextButtons: slideData.products_limit > slideData.products_per_slide,
        initialIndex: 0,
        arrowShape: arrowShape
      });
      slider.on('settle.flickity', function () {
        slider.flickity('resize');
        
      });

    },
    unload: function ($section) {
      let $slider = $section.find('.flickity-enabled');
      $slider.flickity('destroy');
    }
  }

  /******/
})()
  ;